import AxiosService from "./axiosServices";
// const axiosService = new AxiosService();

export default class reviewService {
  getHeaders = () => {
    return {
      headers: {
        "content-Type": "Application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: localStorage.getItem("token"),
      },
    };
  };

  getReviewDataList = (params) => {
    return AxiosService.Get(`api/cam/srm/batches-list/`, {
      params: params,
    });
  };

  getBatchMetaData = (params) => {
    return AxiosService.Get(`api/cam/srm//template/batch/`, {
      params: params,
    });
  };

  getReviewAudit = (params) => {
    return AxiosService.Get(`api/cam/srm/manage/data/audit/`, {
      params: params,
    });
  };
  getReviewMenu = (params) => {
    return AxiosService.Get(
      `api/cam/srm/template/batch/${params.batch_id}/${params.unit_op_id}/${params.ingested_file_id}/`,
      {}
    );
  };

  uploadMediaFiles = (data) => {
    return AxiosService.Post(`api/cam/srm/upload_file/`, data, {
      ...this.getHeaders(),
    });
  };

  updateBatchData = (data) => {
    return AxiosService.Post(`api/cam/srm/edit/batch-meta-data/`, data, {
        ...this.getHeaders(),
    });
  };

  approveBatch = (data) => {
    return AxiosService.Post(`api/cam/srm/approve-batch-rows/`, data, {
      ...this.getHeaders(),
    });
  };

  uploadMedia = (params) => {
    return AxiosService.Post(`api/cam/srm/limits-list/`, {
      params: params,
    });
  };

  downloadTemplate = (params) => {
    return AxiosService.Get(`api/cam/srm/get-uop-template/`, {
      params: params,
    });
  };

  getSummaryList = (params) => {
    return AxiosService.Get(`api/cam/srm/list-ingestion-files/`, {
      params: params,
    });
  };

  approveMultiBatch = (params) => {
    return AxiosService.Post(`api/cam/srm/approve-batches-bulk/`,params);
  };

  getCopiedBatches = (params) => {
    return AxiosService.Get(`api/cam/srm/copied-batches/`, { params });
  };
  getCopyBatchPreview = (params) => {
    return AxiosService.Get(`api/cam/srm/historical-batch-copy-preview/`, {
      params,
    });
  };

  copyBatch = (data) => {
    return AxiosService.Post(`api/cam/srm/update-historical-batch/`, data, {
      ...this.getHeaders(),
    });
  };

  addBatchRow = (data) => {
    return AxiosService.Post(`api/cam/srm/add-batch-row/`, data, {
      ...this.getHeaders(),
    });
  };
  
  getUserList = (params) => {
    return AxiosService.Get(`api/cam/srm/users-list/`, {
      params: params,
    });
  };

   downloadExcelTemplate = (params) => {
    return AxiosService.Get(`api/cam/pc/template-download/`, {
      params: params,
      responseType: "blob",
    });
  };
}
